<template>
    <div style="transition: all 0.2s;" ref="interaction" @touchstart="touchStart" @touchend="touchEnd">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'InteractionOfElementBackgroundColor',
    props: {
        changeColor: {
            type: String,
            default: ''
        },
        originColor: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            touchTimer: null
        }
    },
    methods: {
        // 즉시 인터랙션 적용X => 0.2초뒤에 인터랙션 적용
        // touchStart() {
        //     this.touchTimer = setTimeout(() => {
        //         if (this.$refs.interaction) {
        //             this.$refs.interaction.style.scale = '0.98';
        //         }
        //     }, 200);
        // },
        // touchEnd() {
        //     clearTimeout(this.touchTimer);
        //     if (this.$refs.interaction) {
        //         this.$refs.interaction.style.scale = '1';
        //     }
        // }
        touchStart() {
            this.$refs.interaction.style.backgroundColor = this.changeColor
        },
        touchEnd() {
            this.$refs.interaction.style.backgroundColor = this.originColor
        }
    },
}
</script>

<style scoped></style>